import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { DataSourceActions } from './data-source.store';
import { ViewsHttpService } from '../../services/views-http.service';

@Injectable({ providedIn: 'root' })
export class DataSourceEffects {
  private readonly actions$ = inject(Actions);
  private readonly viewsHttpService = inject(ViewsHttpService);

  public effect = createEffectFactory(DataSourceActions, this.actions$);

  public fetchOne$ = this.effect(DataSourceActions.fetchOne, ({ payload: { id } }) =>
    this.viewsHttpService.fetchDataSource(id).pipe(map(data => ({ data }))),
  );
}
